// Definição para o modal de busca de Documentação de Telas
// Utilizada no cadastro de Regras de Acesso (modal de permissões) para
// vincular telas documentadas a uma permissão granular

export const criarConfigBuscaDocumentacaoTela = () => ({
  label: 'Tela Documentada',
  placeholder: 'ID, Tela ou Título...',
  titulo: 'Selecionar Tela Documentada',
  endpointApi: 'DocumentacaoTela',
  idField: 'idDocumentacaoTela',
  displayField: 'idDocumentacao',
  descField: 'titulo',

  camposFiltro: [
    { label: 'Busca', model: 'search', tipo: 'text' },
    { label: 'Módulo', model: 'modulo', tipo: 'text' },
    { label: 'Tela', model: 'tela', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idDocumentacao', width: '20%' },
    { header: 'Tela', dataField: 'tela', width: '25%' },
    { header: 'Módulo', dataField: 'modulo', width: '15%' },
    { header: 'Título', dataField: 'titulo', width: '40%' }
  ],

  filtrosFixos: {
    pageSize: 100
  }
})
